import styled from 'styled-components';
import Mod001 from 'dc/Mod001';
import { Typ40, Typ41, Typ36 } from 'dc/Typ';
import { Ico72, Ico24 } from 'dc/Ico';
import SwiLab02 from 'dc/SwiLab02';
import SeF003 from 'dc/Sef003';

export const Modal = styled(Mod001)`
  width: 646px !important;
  > div {
    border-radius: 5px;
    box-shadow:
      0 15px 20px rgba(0, 0, 0, 0.22),
      0 19px 60px rgba(0, 0, 0, 0.3);
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: transparent;
  text-align: left;
  padding: 32px;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 76px;
  height: 76px;
  margin-bottom: 11px;
  border-radius: 50%;
  background: #45c5b4;
`;

export const Icon = styled(Ico72)`
  top: -1px;
  position: relative;
`;

export const Title = styled(Typ41)`
  margin-bottom: 20px;
  max-width: 244px;
`;

export const RadiosWrapper = styled.div`
  width: 100%;
  padding-left: 32px;
`;

export const RadioWrapper = styled.div`
  width: 100%;
  margin-bottom: 28px;
  text-align: left;
  display: flex;
  flex-direction: column;
`;

export const Radio = styled(SwiLab02)`
  margin-left: -32px;
  div {
    color: #90a4ae;
  }
  span {
    color: #37474f !important;
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
  }
`;

export const IconTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-left: -32px;
`;

export const FadedIcon = styled(Ico24)`
  color: rgba(38, 50, 56, 0.38);
`;

export const FadedTitle = styled(Typ36)`
  line-height: 20px;
  color: rgba(38, 50, 56, 0.38);
  padding-left: 8px;
`;

export const FadedText = styled(Typ40)`
  color: rgba(38, 50, 56, 0.38);
  width: 100%;
`;

export const Text = styled(Typ40)`
  color: rgba(38, 50, 56, 0.7);
  width: 100%;
`;

export const Footer = styled(SeF003)`
  width: 100%;
  height: 48px;
`;
